import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

interface EditorQuillProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const EditorQuill: React.FC<EditorQuillProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  return (
    <>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        placeholder={placeholder || "Enter message content"}
        style={{ background: "#fff", borderRadius: "10px" }}
      />
    </>
  );
};

export default EditorQuill;
